export const environment = {
  production: false,
  apiUrl: 'https://concurso-api.zoomeduca.com.br/teste/api',
  version: '1.0.0',
  appName: 'Zoom Educa - Portal de Concursos'
};

// # Build para teste
// ng build --configuration=test

// # Servir em modo teste
// ng serve --configuration=test